import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PricingPlan } from "@/model/interface/PricingPlan";
import React from "react";
import RateField from "./RateField";

interface PlanAiOrchestratorRatesSectionProps {
  editing: Partial<PricingPlan>;
  onField: (field: string, value: unknown) => void;
}

export default function PlanAiOrchestratorRatesSection({ editing, onField }: PlanAiOrchestratorRatesSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>AI orchestrator rates</CardTitle>
        <CardDescription>
          Per-minute rates for each AI voice orchestrator. Set independently — VAPI and ElevenLabs
          Conversational AI are external SaaS products with different cost structures; Retreevo Native runs in-house.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <RateField
          label="Vapi (per minute)"
          baseRate={editing.vapiBaseRate ?? 0}
          markupType={editing.vapiMarkupType ?? "FLAT"}
          markupAmount={editing.vapiMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("vapiBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("vapiMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("vapiMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="ElevenLabs Conversational AI (per minute)"
          baseRate={editing.elevenLabsConvaiBaseRate ?? 0}
          markupType={editing.elevenLabsConvaiMarkupType ?? "FLAT"}
          markupAmount={editing.elevenLabsConvaiMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("elevenLabsConvaiBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("elevenLabsConvaiMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("elevenLabsConvaiMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Retreevo Native (per minute)"
          baseRate={editing.nativeAiBaseRate ?? 0}
          markupType={editing.nativeAiMarkupType ?? "FLAT"}
          markupAmount={editing.nativeAiMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("nativeAiBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("nativeAiMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("nativeAiMarkupAmount", newMarkupAmount)}
        />
      </CardContent>
    </Card>
  );
}
